import React, { Fragment } from 'react'
import { useHome, HomeProps } from './useHome'
import Layout from 'components/Layout/Layout'
import Info from './Info/Info'
import Categories from './Categories/Categories'
import SubCategories from './SubCategories/SubCategories'
import Loader from 'screens/Loader/Loader'
import NotFound from 'screens/NotFound/NotFound'
import Announcement from 'components/Announcement/Announcement'

const Home: React.FC<HomeProps> = (props: HomeProps) => {
  const {
    isLoading,
    isRestaurantFound,
    activeCategory,
    announcementTitle,
    announcementDescription,
    showAnnouncementBox,
    setShowAnnouncementBox,
    handleCategoryClick,
  } = useHome(props)

  return isLoading ? (
    <Loader />
  ) : isRestaurantFound ? (
    <Layout>
      <main>
        <Info />
        <Categories
          activeCategory={activeCategory}
          handleCategoryClick={handleCategoryClick}
        />
        <SubCategories activeCategory={activeCategory} />
        {showAnnouncementBox && announcementTitle && announcementDescription ? (
          <Announcement
            title={announcementTitle}
            content={announcementDescription}
            setShowAnnouncementBox={setShowAnnouncementBox}
          />
        ) : (
          <Fragment />
        )}
      </main>
    </Layout>
  ) : (
    <NotFound />
  )
}

export default Home
